/**
 * Arabic Common Translations
 * 通用翻译模块 - 阿拉伯语
 * 
 * 包含导航栏 (nav) 和页脚 (footer) 的翻译
 */

import type { CommonTranslations } from '../../types';

export const arCommon: CommonTranslations = {
  nav: {
    home: 'الرئيسية',
    products: 'المنتجات',
    technology: 'التقنية',
    about: 'من نحن',
    contact: 'اتصل بنا',
    faq: 'الأسئلة الشائعة',
  },
  footer: {
    contact: 'اتصل بنا',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    rights: 'جميع الحقوق محفوظة.',
    brandDesc: 'الشركة المصنعة المهنية لمدافئ الإشعاع تحت الحمراء. نقدم الدفء والراحة وكفاءة الطاقة للعالم منذ عام 2006.',
    products: 'المنتجات',
    support: 'الدعم',
    newsletter: 'ابق على اطلاع',
    newsletterDesc: 'اشترك للحصول على آخر تحديثات المنتجات وأخبار الصناعة.',
    join: 'انضم',
    catalog: 'تحميل الكتالوج',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    product1: 'سخان بالأشعة تحت الحمراء',
    product2: 'سخان محمول',
    product3: '',
    product4: '',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    sitemap: 'خريطة الموقع',
    installationGuide: 'دليل التركيب',
    warrantyPolicy: 'سياسة الضمان',
  },
};
